import { Injectable } from '@angular/core';
import { DialogType } from 'src/app/components/shared/dialog/dialog.interface';
import { GridButtonMode } from 'src/app/components/shared/grid-components/grid-button/grid-button.interface';

@Injectable({
    providedIn: 'root'
})

export class DegradationPathwayColdef {
  public getColumnsDefinition(): any[] {
    return [
      {
        headerName: "",
        field: "selected",
        cellRenderer: "checkBoxRenderer",
        maxWidth: 35,
        minWidth: 35,
        resizable: false,
        editable: false,
        pinned : true
      },
      {
      headerName: "Precursor",
      field: "precursor",
      columnGroupShow: "open",
      maxWidth: 150,
      minWidth: 150,
      resizable: true,
      editable: false,
      pinned : true,
      cellRenderer: "dropdownRenderer",
      cellRendererParams: {
          source: "precursor",
          valueDefinition: "name"
        }
      },
      {
        headerName: "Metabolite",
        field: "metabolite",
        columnGroupShow: "open",
        maxWidth: 150,
        minWidth: 150,
        resizable: true,
        editable: false,
        pinned : true,
        cellRenderer: "dropdownRenderer",
        cellRendererParams: {
            source: "metabolite",
            valueDefinition: "name"
        }
      },
      {
        headerName: "Precursor SMILES",
        field: "precursorSmiles",
        maxWidth: 140,
        minWidth: 140,
        resizable: true,
        editable: false,
        disabled: true,
        cellRenderer: "textAreaRenderer",
        cellRendererParams: {
          rows: 5,
          disabled: true
        }
      },
      {
        headerName: "Metabolite SMILES",
        field: "metaboliteSmiles",
        maxWidth: 140,
        minWidth: 140,
        resizable: true,
        cellRenderer: "textAreaRenderer",
        cellRendererParams: {
            rows: 5,
            disabled: true
        }
      },
      {
        headerName: "Biosystems",
        children:
        [
          {
            headerName: "Level I",
            field: "levelI",
            resizable: false,
            editable: false,
            maxWidth: 160,
            minWidth: 160,
            cellRenderer: "listBoxselectionRenderer",
            cellRendererParams: {
              code: "BMLI",
              module: "CONF",
              link: "levelII",
              readOnly: true,
              firstFilter: true,
              useRefData: true
            },
            filter: "ListboxFilter",
            filterParams: {
                source:"dropdownvalue"
            }
          },
          {
            headerName: "Level II",
            field: "levelII",
            resizable: false,
            editable: false,
            maxWidth: 160,
            minWidth: 160,
            cellRenderer: "listBoxselectionRenderer",
            cellRendererParams: {
              code: "BMLII",
              module: "CONF",
              link: "levelIII",
              readOnly:true,
              useRefData: true
            },
            filter: "ListboxFilter",
            filterParams: {
              source: "dropdownvalue"
            }
          },
          {
            headerName: "Level III",
            field: "levelIII",
            editable: false,
            resizable: true,
            maxWidth: 160,
            minWidth: 160,
            cellRenderer: "listBoxselectionRenderer",
            cellRendererParams: {
              code: "BMLIII",
              module: "CONF",
              link: "levelIV",
              readOnly:true,
              useRefData: true
            },
            filter: "ListboxFilter",
            filterParams: {
              source: "dropdownvalue"
            }
          },
          {
            headerName: "Level IV",
            field: "levelIV",
            editable: false,
            resizable: true,
            maxWidth: 160,
            minWidth: 160,
            cellRenderer: "listBoxselectionRenderer",
            cellRendererParams: {
              code: "BMLIV",
              module: "CONF",
              link: "levelV",
              readOnly:true,
              useRefData: true
            },
            filter: "ListboxFilter",
            filterParams: {
                source: "dropdownvalue"
            }
          },
          {
            headerName: "Level V",
            field: "levelV",
            editable: false,
            resizable: true,
            maxWidth: 160,
            minWidth: 160,
            cellRenderer: "listBoxselectionRenderer",
            cellRendererParams: {
              code: "BMLV",
              module: "CONF",
              link: "levelVI",
              readOnly:true,
              useRefData: true
            },
            filter: "ListboxFilter",
            filterParams: {
              source: "dropdownvalue"
            }
         }
        ]
      },
      {
        headerName: "Pathway URL",
        field: "pathwayUrl",
        maxWidth: 130,
        minWidth: 130,
        resizable: true,
        editable: false,
        pinned: false,
        cellRenderer: "gridButtonRenderer",
        cellRendererParams: {
          fieldToEvaluate: 'pathwayUrl',
          mode: GridButtonMode.Add,
          type: DialogType.PathwayUrl,
          visible: true
        }
      },
      {
        headerName: "View Pathway",
        field: "pathwayUrl",
        maxWidth: 130,
        minWidth: 130,
        resizable: true,
        editable: false,
        cellRenderer: "gridButtonRenderer",
        cellRendererParams: params => {
          return{
            mode: GridButtonMode.View,
            visible: params?.data?.pathwayUrl
          }
        }
      }
    ]
  }
}
